export const MILLISECONDS_SECOND = 1000
export const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND
export const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE
export const MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR
export const DELAY = 1000

export function getTime(date) {
  return +new Date(date) - +Date.now()
}

export function getFormattedTime(secondsRemaining) {
  const hours = Math.floor(secondsRemaining / (60 * 60))
  const minutes = Math.floor((secondsRemaining % (60 * 60)) / 60)
  const seconds = secondsRemaining % 60

  const formattedHours = hours < 10 ? '0' + hours : hours
  const formattedMinutes = minutes < 10 ? '0' + minutes : minutes
  const formattedSeconds = seconds < 10 ? '0' + seconds : seconds

  return hours > 0
    ? `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    : `${formattedMinutes}:${formattedSeconds}`
}
